import React from 'react';
import {
    withStyles,
    Grid,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import NoMatch from './NoMatch';
import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis';
import PreviewTwoItem from '../view/PreviewTwoItem';
import { NewsItem } from './view';

class NewsMore extends React.Component {
    constructor(props) {
        super(props);

        let data = props.location.data;
        if (!data) {
            data = AppUtils.getStorageObj('NewsMore');
        }
        AppUtils.setStorageObj('NewsMore', data)

        this.state = {
            data: [],
        };
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'NewsMore');
        this.getNewsList();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getNewsList = async () => {
        let result = await Apis.encryptionNewsList();
        console.log('getNewsList', result);
        if (result.code == 200) {
            this.setState({ data: result.data });
        }
    }


    render() {
        const { classes } = this.props;
        const { data } = this.state;
        return (
            <MBack title='新闻'>
                <Grid container justifyContent='flex-start' direction='row' alignItems='center' className={classes.content}>
                    {
                        data.length > 0 && data.map((item, i) => (
                            <Grid key={i} container alignItems='center' style={{ maxWidth: '50vw', paddingLeft: 8, marginBottom: 16 }}>
                                <NewsItem data={item}></NewsItem>
                            </Grid>
                        ))
                    }
                    {
                        data.length == 0 && <NoMatch />
                    }
                </Grid>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    content: {
        padding: theme.spacing(4, 0, 0, 0),
    },
}))(NewsMore));